import React from 'react'
import { CTA_SIZE, CTA_TYPE } from '../../../data/constants';
import { isMobileDevice } from '../../../helpers/device-info-helper';
import CtaComponent from '../../../components/reusable-ui/cta';
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { isSourcePos } from '../../../helpers/common-helper';

interface Props{
  hideAddEditTransaction: any;
  isEditMode: boolean;
  resetTransactionForm: any;
  submitTransaction: any;
  checkToEnableEdit: any;
  checkToEnableAdd: any;
}

function AddEditHeader({hideAddEditTransaction, isEditMode, resetTransactionForm, submitTransaction, checkToEnableEdit, checkToEnableAdd}:Props) {
  return (
    <div className="flex justify-between items-center w-full border-b border-[#DDDDDD] px-24 py-20 sm:px-15 sm:py-10">
      <div className="flex items-center gap-10">
        {isSourcePos() ? null : (
          <KeyboardBackspaceIcon
            sx={{ fontSize: "28px", cursor: "pointer" }}
            onClick={hideAddEditTransaction}
          />
        )}
        <p className="text-18 font-semibold">
          {isEditMode ? "Edit" : "Add"} Transaction
        </p>
      </div>
      <div className="btn-part-cnt flex items-center">
        <CtaComponent
          ctaText={isEditMode ? "Discard" : "Clear"}
          ctaType={CTA_TYPE.secondary_cta}
          ctaSize={isMobileDevice() ? CTA_SIZE.small : CTA_SIZE.medium}
          onCtaClick={resetTransactionForm}
          customClass={"mr-10 sm:mr-[8px]"}
        ></CtaComponent>
        {isEditMode ? (
          <CtaComponent
            ctaText={"Save"}
            ctaType={CTA_TYPE.active_cta}
            ctaSize={isMobileDevice() ? CTA_SIZE.small : CTA_SIZE.medium}
            onCtaClick={submitTransaction}
            customClass={"ml-10 sm:ml-[8px] py-6 sm:hidden"}
            isDisabled={checkToEnableEdit()}
          ></CtaComponent>
        ) : (
          <CtaComponent
            ctaText={"Add"}
            ctaType={CTA_TYPE.active_cta}
            ctaSize={isMobileDevice() ? CTA_SIZE.small : CTA_SIZE.medium}
            onCtaClick={submitTransaction}
            customClass={"ml-10 sm:ml-[8px] py-6 sm:hidden"}
            isDisabled={checkToEnableAdd()}
          ></CtaComponent>
        )}
      </div>
    </div>
  );
}

export default AddEditHeader;